var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"capsule",class:("type-" + _vm.value)},[_vm._v("\n  "+_vm._s(_vm.$t(("types[" + (JSON.stringify(_vm.value)) + "]")))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }